export const modeLabel = document.getElementById("mode-label")!;
export const lenLabel = document.getElementById("len-label")!;
export const solutionsLabel = document.getElementById("solutions-label")!;
export const cantusInput = document.getElementById(
    "cantus-string",
)! as HTMLInputElement;
export const hand = document.getElementById("hand");
export const fist = document.getElementById("fist");
export const scrollOpen = document.getElementById("scroll-open");
export const scrollRolled = document.getElementById("scroll-rolled");
